module.exports = __webpack_public_path__ + "static/media/navidad17.54727c28.webp";